export enum GameLaunchMode {
    Modal = 'modal',
    NewTab = 'new-tab',
    SameTab = 'same-tab',
    Auto = 'auto',
}

/** Runtime mode after resolving Auto (Auto itself is never returned). */
export type LaunchMode =
    | GameLaunchMode.Modal
    | GameLaunchMode.NewTab
    | GameLaunchMode.SameTab;

export const DEFAULT_GAME_LAUNCH_MODE = GameLaunchMode.Auto;

export const SUPPORTED_GAME_LAUNCH_MODES = new Set<string>(Object.values(GameLaunchMode));

export const GAME_LAUNCH_RETURN_URL_PARAM = 'return_to';
export const GAME_LAUNCH_OPEN_CONTEXT_PARAM = 'open_context';
export const GAME_LAUNCH_CHEATS_ENABLED_PARAM = 'cheatsEnabled';
export const ATEMOYA_CHEATS_ALLOWED_STORAGE_KEY = 'ATEMOYA_CHEATS_ALLOWED';
export const GAME_LAUNCH_PARENT_ORIGIN_PARAM = 'parent_origin';
